export { default } from "./clinicRequestDialog";
